module.exports = __webpack_public_path__ + "img/02-expanded-coverage.d9810d6c.jpg";